import { render, staticRenderFns } from "./UserStatusBadge.vue?vue&type=template&id=47c0fdf1&scoped=true"
import script from "./UserStatusBadge.vue?vue&type=script&lang=ts"
export * from "./UserStatusBadge.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c0fdf1",
  null
  
)

export default component.exports